import { type CustomerEditableField } from "../../types/customer.types.ts"

type CustomerFieldKind = "text" | "email" | "phone" | "notes" | "zip"

interface CustomerCardField {
  name: CustomerEditableField
  labelKey: string
  kind?: CustomerFieldKind
  /** Columns out of 24 the field takes on `sm` and up. */
  span?: number
}

interface CustomerCardSpec {
  cardId: string
  titleKey: string
  fields: CustomerCardField[]
}

const CUSTOMER_CARDS = {
  profile: {
    cardId: "profile",
    titleKey: "customerDetail.cards.profile",
    fields: [
      { name: "first_name", labelKey: "customerDetail.fields.firstName" },
      { name: "middle_name", labelKey: "customerDetail.fields.middleName" },
      { name: "last_name", labelKey: "customerDetail.fields.lastName" }
    ]
  },
  contact: {
    cardId: "contact",
    titleKey: "customerDetail.cards.contact",
    fields: [
      { name: "email", labelKey: "customerDetail.fields.email", kind: "email" },
      { name: "phone", labelKey: "customerDetail.fields.phone", kind: "phone" },
      {
        name: "phone_2",
        labelKey: "customerDetail.fields.phone2",
        kind: "phone"
      },
      {
        name: "phone_3",
        labelKey: "customerDetail.fields.phone3",
        kind: "phone"
      }
    ]
  },
  address: {
    cardId: "address",
    titleKey: "customerDetail.cards.address",
    fields: [
      { name: "address", labelKey: "customerDetail.fields.address" },
      { name: "address_2", labelKey: "customerDetail.fields.address2" },
      { name: "city", labelKey: "customerDetail.fields.city" },
      { name: "state", labelKey: "customerDetail.fields.state" },
      {
        name: "zip_code",
        labelKey: "customerDetail.fields.zipCode",
        kind: "zip"
      }
    ]
  },
  notes: {
    cardId: "notes",
    titleKey: "customerDetail.cards.notes",
    fields: [
      {
        name: "notes",
        labelKey: "customerDetail.fields.notes",
        kind: "notes",
        span: 24
      }
    ]
  }
} satisfies Record<string, CustomerCardSpec>

export { CUSTOMER_CARDS, type CustomerCardField, type CustomerCardSpec }
